import { Expose, Type } from 'class-transformer';
import { Model } from '@shared/models/model';

export class TopRoute extends Model {
  @Expose() fromCityId: number;
  @Expose() fromCityName: string;
  @Expose() toCityId: number;
  @Expose() toCityName: string;
  @Expose() total: number;
}

export class TopRoutes extends Model {
  @Expose() totalShipments: number;
  @Expose() @Type(() => TopRoute) routes: TopRoute[];
}
